@import '~style-sheet-helpers/core.less';
@import '../../../../../../constants/screen-width-breakpoints.module.less';
@import '../../../../../../constants/spacing.module.less';

.header {
  font-weight: 700;
}

.carriers-container {
  align-items: center;
  width: 100%;
}

.carriers-step-header {
  text-align: left;
  margin: 0 10%;

  @media @mobile, @ultramobile {
    margin: 0;
  }
}

.inner-background-section {
  background-color: var(--white);
  border-radius: 8px;
  padding: @space-24;
  width: 80%;
  margin: @space-24 0;
  align-self: center;
  border: 1px solid var(--gray-E4E5E7);

  @media @mobile, @ultramobile {
    width: 100%;
    padding: @space-16;
  }
}

.carriers-logos {
  align-items: center;
  justify-content: center;
  margin-bottom: @space-16;

  img {
    max-width: 100%;
    height: auto;
  }
}

.saving-message {
  text-align: center;
  margin: @space-16 0;
}

.setup-button {
  margin: @space-16 0 @space-8;
  min-width: 150px;
  background-color: var(--green-0D6E3F);
  color: var(--white);
  border-radius: 4px;
  padding: @space-8 @space-16;
  font-weight: 500;
}

.card-info {
  border: 1px solid var(--gray-E4E5E7);
  border-radius: 4px;
  overflow: hidden;
  width: 80%;
  margin: 0 auto;
  background-color: var(--white);

  @media @mobile, @ultramobile {
    width: 100%;
  }
}

.payment-table {
  width: 80%;

  @media @mobile, @ultramobile {
    width: 100%;
    overflow-x: auto;
  }
}

.payment-row {
  width: 100%;
  justify-content: space-between;
  border-bottom: 1px solid var(--gray-E4E5E7);
}

.payment-row.table-header {
  background-color: var(--gray-F7F8F9);
}

.payment-row.table-subheader {
  background-color: var(--white);
  border-bottom: none;
}

.payment-row.table-row {
  height: 48px;
  border-bottom: none;
}

.left-header-cell {
  text-align: left;
  padding: @space-12 @space-16;
  color: var(--gray-666666);
}

.right-header-cell {
  text-align: right;
  padding: @space-12 @space-16;
  justify-content: flex-end;
}

.left-store-cell {
  text-align: left;
  padding: @space-12 @space-16;
  font-size: 14px;
  color: var(--gray-333333);
}

.payment-method {
  align-items: center;
}

.edit-icon {
  margin-right: @space-4;
  width: 12px;
  height: 12px;
}

.success-message {
  margin: @space-24 auto;
  width: 80%;

  @media @mobile, @ultramobile {
    width: 100%;
  }
}

.setup-buttons {
  justify-content: space-between;
  width: 80%;

  @media @mobile, @ultramobile {
    width: 100%;
  }
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 200px;
}

.todo-cards-wrapper {
  width: 80%;
  margin: 0 auto;
  text-align: left;

  @media @mobile, @ultramobile {
    width: 100%;
  }
}
